<template>
  <section class="info-panel-item">
    <span>
      {{ title }}
    </span>
    <div class="info-content"><slot /></div>
  </section>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss" scoped>
.info-panel-item {
  span {
    display: block;
    text-align: left;
    font: normal normal normal 14px/28px Lato;
    letter-spacing: 0px;
    color: #727272;
    position: relative;
    top: 6px;
  }
  .info-content {
    text-align: left;
    color: #11291b;
    min-width: 100px;
  }
}
</style>
